import Content from "../layout/Content/Content";
import ManageBlocks from "../pages/ManageBlocks/ManageBlocks";
import ManageDemos from "../pages/ManageDemos/ManageDemos";
import ManageShowrooms from "../pages/ManageShowrooms/ManageShowrooms";
import ManageCalendar from "../pages/ManageCalendar/ManageCalendar";
import Reports from "../pages/Reports/Reports";
import ProtectedRoute from "./ProtectedRoute";
import { Route_types } from "../types/routes/RouteTypes";
import { Routes } from "../enums/Routes";

const AuthRoutes: Route_types[] = [
  {
    element: <Content />,
    children: [
      {
        path: Routes.Showrooms,
        element: (
          <ProtectedRoute>
            <ManageShowrooms />
          </ProtectedRoute>
        )
      },
      {
        path: Routes.Demos,
        element: (
          <ProtectedRoute>
            <ManageDemos />
          </ProtectedRoute>
        )
      },
      {
        path: Routes.Blocks,
        element: (
          <ProtectedRoute>
            <ManageBlocks />
          </ProtectedRoute>
        )
      },
      {
        path: Routes.Calendar,
        element: (
          <ProtectedRoute>
            <ManageCalendar />
          </ProtectedRoute>
        )
      },
      {
        path: Routes.Reports,
        element: <Reports />
      },
      {
        path: "*",
        element: <ProtectedRoute />
      }
    ]
  }
];
export default AuthRoutes;
